import ModalSkeleton from "@/components/ModalSkeleton";
import { mergeClass } from "@/utils/helper";
import Button from "../../components/Button";
import { WarningIcon } from "../../constant/imagePath";
import classes from "./AreYouSureModal.module.css";

const AreYouSureModal = ({
  show,
  setShow,
  action,
  userName,
  onClick,
  isApiCall,
  permission,
  title,
}) => {
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        showCloseIcon={true}
        showLogo={true}
        modalClass={classes.modalBody}
        modalStyles={classes.modal}
        iconDiv={classes.closeIcon}
      >
        <div className={classes.bodyDiv}>
          <div className={classes.warningDiv}>
            <img src={WarningIcon} alt="warningIcon" />
          </div>
          {userName && <p>{`${title} ${userName}`}</p>}
          {permission && (
            <div>
              <p>You do not have permission to perform this action.</p>
              <p>Contact your permissions manager.</p>
            </div>
          )}
        </div>
        <div
          className={mergeClass(
            permission && classes.buttonDivTwo,
            classes.buttonDiv
          )}
        >
          {!permission && (
            <Button
              className={classes.buttonOne}
              variant={"secondary-outlined"}
              onClick={async () => {
                setShow(null);
              }}
              disabled={isApiCall}
            >
              Cancel
            </Button>
          )}
          <Button
            className={mergeClass(
              classes.buttonTwo,
              permission && classes.yesBtn
            )}
            onClick={onClick}
            disabled={isApiCall}
            variant={"green-gradient"}
          >
            {isApiCall ? "Wait..." : `${permission ? "Done" : "Confirm"}`}
          </Button>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default AreYouSureModal;
